import React from "react";
import "../styles/Designs.css";

function Designs() {

  const kitchenImages = [
    "/kitchen/kitchen18.jpeg",
    "/kitchen/kitchen20.jpeg",
    "/kitchen/kitchen23.jpeg",
    "/kitchen/kitchen19.jpeg",
    "/kitchen/kitchen21.jpeg",
    "/kitchen/kitchen22.jpeg",
    "/kitchen/kitchen27.jpeg",
    "/kitchen/kitchen38.jpeg",
    "/kitchen/kitchen39.jpeg",
    "/kitchen/kitchen25.jpeg",
    "/kitchen/kitchen28.jpeg",
    "/kitchen/kitchen30.jpeg",
    "/kitchen/kitchen33.jpeg",
    "/kitchen/kitchen34.jpeg",
    "/kitchen/kitchen35.jpeg",
    "/kitchen/kitchen36.jpeg",
    "/kitchen/kitchen37.jpeg",
];

  

  

  

  return (
    <>

      {/* HERO BANNER */}
      <section className="design-banner">
        <div className="banner-overlay">
          <h1>Our Interior Designs</h1>
          <p>Explore stunning designs for every space of your home</p>
        </div>
      </section>

      {/* DESIGN SECTION */}
      <section className="popular-designs">
        <div className="container">

          <h2>Popular Interior Designs for Every Space</h2>

          <p className="design-subtitle">
            Discover stunning ideas for kitchens, bedrooms, living rooms and bathrooms.
          </p>

          {/* Kitchen */}
          <h3 className="room-title">Our Designs</h3>
          <div className="design-grid">
            {kitchenImages.map((img, index) => (
              <div key={index} className="grid-item">
                <img src={img} alt="Kitchen Design"/>
              </div>
            ))}
          </div>
   </div>
      </section>

    </>
  );
}

export default Designs;